import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import cbamImage from '@/assets/EU-Carbon-Border-Adjustment-Mechanism-CBAM.png.webp'
import lexMachinaImage from '@/assets/lex-machina.jpg.webp'
import batteryRegulationImage from '@/assets/The-EU-Battery-Regulation.png.webp'
import cyberSecurityImage from '@/assets/cyber-security-1.png (1).webp'
import restrictiveMeasuresImage from '@/assets/EU-Restrictive-Measures.png.webp'

const images = [
  cbamImage,
  lexMachinaImage,
  batteryRegulationImage,
  cyberSecurityImage,
  restrictiveMeasuresImage
]

export default function AuthImageCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % images.length)
    }, 4000) // Change image every 4 seconds

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="relative w-[400px] h-[500px] flex items-center justify-center overflow-hidden bg-white rounded-lg">
      <AnimatePresence mode="wait">
        <motion.img
          key={currentIndex}
          src={images[currentIndex]}
          alt="Artem feature showcase"
          className="max-w-full max-h-full object-contain rounded-lg"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{
            duration: 0.7,
            ease: 'easeInOut'
          }}
        />
      </AnimatePresence>
    </div>
  )
}
